import { configureStore, combineReducers  } from "@reduxjs/toolkit";
import countSlice from "./slices/countSlice"
import forgotPasswordReducer from "./slices/forgotPasswordSlice";
import resetPasswordReducer from "./slices/resetPasswordSlice";
import authReducer from "./slices/authSlice";
import changePasswordReducer from "./slices/changePasswordSlice"; 
import passwordChangedReducer from "./slices/passwordChangedSlice";

import resetAuthReducer from "./slices/resetAuthSlice";
import jobReducer from "./slices/jobSlice"; 
const reducers = {
  count:countSlice,

  forgotPassword: forgotPasswordReducer, // Add Forgot Password slice

  resetPassword: resetPasswordReducer,

  auth: authReducer,

  changePassword: changePasswordReducer, // ✅ Change Password state

  passwordChanged: passwordChangedReducer, // ✅ Manage password success state

 
  resetAuth: resetAuthReducer, 

  job: jobReducer,
  
}
const subAppOnboardingReducer = combineReducers(reducers);
const store = configureStore({
  reducer: subAppOnboardingReducer,
});

// Export the combined reducer for MainApp
export { reducers as subAppOnboardingReducer }; // Add this
export default store; // Keep for standalone use
